import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: ${({ theme }) => theme.spacing * 8}px;
    background-color: #F8FAFD;
    border-radius: 6px;
    >p {
        font-weight: bold;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
        font-size: 14px;
        text-align: center;
    }
`;

export const Element = styled.div`
    margin: ${({ theme }) => theme.spacing * 15}px 0;
`;

export const ElementTitle = styled.div`
    width: 170px;
    height: 12px;
    background-color: #C8D1DC;
    margin-bottom: ${({ theme }) => theme.spacing * 7}px;
`;

export const ElementName = styled.div`
    width: 90px;
    height: 8px;
    background-color: #C8D1DC;
    margin-right: ${({ theme }) => theme.spacing * 9}px;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
`;

export const ElementDescription = styled.div`
    width: 170px;
    height: 8px;
    background-color: #E1E7ED;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
`;

export const FlexWrapper = styled.div`
    display: flex;
`;
